/**
 * By li si yi
 * 业务开关弹出框组件
 */
import React, {Component} from 'react';
import {Modal, Button, message, Switch} from "antd";
import BaseComponent from "../../../../base/BaseComponent";
import BaseTable from "../../../components/baseTable/BaseTable";
import {Scrollbars} from "react-custom-scrollbars";

export default class BusinessSwitch extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            currentClick: {}
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {
        return (
            <div>
                {this.renderModal()}
            </div>
        )
    }

    // 弹框
    renderModal = () => {
        let {dataSource, columns} = this.props;
        let {currentClick} = this.state;
        return (
            <div style={{display: 'flex'}}>
                <div>
                    <Modal
                        className={'deptLoginModal'}
                        title={currentClick.name}
                        visible={this.state.visible}
                        centered={true}
                        onOk={this.handleOk}
                        onCancel={this.handleCancel}
                        width={800}
                        maskClosable={false}
                    >
                        <Scrollbars style={{height: 400}} autoHide>
                            <BaseTable rowKey="id" dataSource={dataSource}
                                       columns={columns}
                                       pagination={false}/>
                        </Scrollbars>
                    </Modal>
                </div>
            </div>
        )
    };
    // 更新开关按钮状态
    updateBusinessSwitch = () => {
        let params = {
            deptId: this.props.currentClickDept.id,
            businessModuleCode: this.props.bindModuleBusiness,// 绑定的业务合集
        };
        let that=this;
        this.request({
            url: "/cm-sites-sys/businessModule/updateBindBussinessModules",
            method: 'post',
            contentType: 'json',
            body: params,
            callBack: (res) => {
                that.props.getDeptAndOpenSwitch();
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        })
    };
    // 显示
    showModal = ({item = [], callBack = () => {}}) => {
        this.callBack = callBack;
        this.setState({
            visible: true,
            currentClick: item,
        });
    };
    // 确定
    handleOk = (callback) => {
        this.updateBusinessSwitch();
        this.setState({
            visible: false,
        });
    };
    // 取消
    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };
    switchOnChange = (checked) => {
        console.log(`switch to ${checked}`);
    }
};

BusinessSwitch.defaultProps = {
    currentClickDept:{},
    bindModuleBusiness:[],
};
BusinessSwitch.propTypes = {};